<script lang="ts">
  import type {
    NhlGameDataResponse,
    NhlPlayByPlayResponse,
    NhlStatKey,
  } from '@statmuse/core/gamera/index'
  import * as store from './stores'
  import { onMount } from 'svelte'
  import type { NhlPlayersMediaQuery } from '@statmuse/core/../graphql/graphql'

  export let gameData: NhlGameDataResponse<NhlStatKey>
  export let playByPlay: NhlPlayByPlayResponse
  export let players: Record<
    string,
    NonNullable<NhlPlayersMediaQuery['nhl']['players']>[number] | undefined
  >

  onMount(() => {
    store.init({ gameData, playByPlay, players })
    return () => store.init({})
  })
</script>
